const RECOVERY_KEY_PREFIX = 'page-recovery:'

export function getPageRecoveryKey(fullPath: string) {
  return `${RECOVERY_KEY_PREFIX}${fullPath}`
}

export function hasPageRecoveryAttempted(fullPath: string): boolean {
  if (!import.meta.client) return false
  try {
    return !!sessionStorage.getItem(getPageRecoveryKey(fullPath))
  } catch {
    return false
  }
}

export function markPageRecoveryAttempted(fullPath: string) {
  if (!import.meta.client) return
  try {
    sessionStorage.setItem(getPageRecoveryKey(fullPath), '1')
  } catch { /* ignore */ }
}

export function clearPageRecoveryAttempt(fullPath: string) {
  if (!import.meta.client) return
  try {
    sessionStorage.removeItem(getPageRecoveryKey(fullPath))
  } catch { /* ignore */ }
}

/** Refresh Shopware session context; falls back to direct API call if composable fails. */
export async function refreshContextSilently() {
  try {
    const { refreshSessionContext } = useSessionContext()
    await refreshSessionContext()
    return
  } catch {
    // error page or stale state — try direct API refresh
  }

  const { apiClient } = useShopwareContext()
  const { setContext } = useSessionContext()
  const response = await apiClient.invoke('readContext get /context')
  if (response.data) {
    setContext(response.data)
  }
}

/**
 * First attempt: refresh context + hard reload (no alert).
 * Returns true if a reload was triggered.
 */
export async function recoverPageWithHardReload(fullPath: string): Promise<boolean> {
  if (hasPageRecoveryAttempted(fullPath)) {
    return false
  }

  try {
    await refreshContextSilently()
  } catch (err) {
    console.warn('[page-recovery] context refresh failed, hard reloading anyway', err)
  }

  markPageRecoveryAttempted(fullPath)
  window.location.reload()
  return true
}
